import {
	SET_FORM_STATE,
	RESET_FIELDS,
	GET_CLUSTERS_NAMES,
	GET_CLUSTERS_DETAILS,
	GET_SUPER_CLUSTERS,
	GET_VMO2_REPORT_DATES
} from '../actions/ReportsKpisActions';

const initialState = {
	clustersNames: [],
	clusterDetails: [],
	vmo2ReportDates: [],
	formState: {
		values: {
			exportCellsDetails: false,
			exportTopOffendersDetails: false
		},
		isValid: false,
		touched: {},
		errors: {}
	}
};

const reportsKpisReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							drives: [],
							dates: []
						};
					}
					case GET_CLUSTERS_NAMES: {
						return {
							...state,
							clustersNames: action.clustersNames
						};
					}
					case GET_SUPER_CLUSTERS: {
						return {
							...state,
							superClusters: action.superClusters
						};
					}
					case GET_CLUSTERS_DETAILS: {
						return {
							...state,
							clusterDetails: action.clusterDetails
						};
					}
					case GET_VMO2_REPORT_DATES: {
						return {
							...state,
							vmo2ReportDates: action.vmo2ReportDates
						};
					}
					default: {
						return state;
					}
	}
};

export default reportsKpisReducer;
